import Home from './Home.data-manager-cdn.vue'

export default {
  Home
}